import React from 'react';
import { CheckCircle, Copy, Check } from 'lucide-react';
import { Button } from '../ui/button';

const ConfirmationHero = ({
  bookingRef,
  onCopyRef,
  copied,
  onWhatsAppClick,
  onEmailClick,
}) => {
  return (
    <div className="bg-white rounded-2xl p-8 md:p-10 text-center max-w-xl mx-auto shadow-lg" data-testid="confirmation-hero">
      {/* Success Icon */}
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <CheckCircle className="h-12 w-12 text-green-500" />
      </div>

      {/* Title */}
      <h1 className="text-3xl font-bold text-black mb-2 font-display">
        Booking Confirmed
      </h1>
      <p className="text-gray-500 mb-6">
        Your driver details will be shared before pickup.
      </p>

      {/* Booking Reference */}
      <div className="bg-gray-50 rounded-xl p-4 mb-6">
        <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">
          Booking Reference
        </p>
        <div className="flex items-center justify-center gap-3">
          <span className="text-2xl font-bold text-black font-mono tracking-wider">
            {bookingRef}
          </span>
          <button
            onClick={onCopyRef}
            className="p-2 rounded-lg hover:bg-gray-200 transition-colors"
            data-testid="copy-ref-btn"
          >
            {copied ? (
              <Check className="h-5 w-5 text-green-500" />
            ) : (
              <Copy className="h-5 w-5 text-gray-400" />
            )}
          </button>
        </div>
        {/* Status Badge */}
        <div className="mt-3">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-[#FF8C00]/10 text-[#FF8C00] border border-[#FF8C00]/30">
            <span className="w-2 h-2 rounded-full bg-[#FF8C00]" />
            Confirmed
          </span>
        </div>
      </div>

      {/* Primary CTAs */}
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          onClick={onWhatsAppClick}
          className="bg-[#25D366] hover:bg-[#20BD5A] text-white h-12 px-6 text-base font-semibold"
          data-testid="whatsapp-btn"
        >
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          Message on WhatsApp
        </Button>
        <Button
          onClick={onEmailClick}
          variant="outline"
          className="bg-white border-gray-300 text-gray-900 hover:bg-gray-100 hover:text-gray-900 h-12 px-6"
          data-testid="email-btn"
        >
          View Booking Details
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationHero;
